<template>
  <el-dialog
    :title="type == 'add' ? '添加校车路线信息' : '编辑校车路线信息'"
    :visible.sync="showDialog"
    :modal-append-to-body="false"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="close"
    width="70%"
  >
    <div class="dlialog-box">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
        style="width:calc(100% - 20px)"
      >
        <el-form-item label="路线名称:" prop="routeName">
          <el-input
            v-model.trim="ruleForm.routeName"
            size="small"
            clearable
            style="width:100%"
          ></el-input>
        </el-form-item>
        <el-form-item label="预计时间:">
          <el-input
            v-model.trim="ruleForm.routeDrivingTime"
            size="small"
            clearable
            style="width:100%"
            ><template slot="append">分钟</template></el-input
          >
        </el-form-item>
        <el-form-item label="站点:">
          <span>共{{ ruleForm.schoolBusSiteList.length || 0 }}站</span>
          <el-button
            class="site_add_box"
            type="success"
            plain
            @click="addSiteClick"
            size="mini"
            icon="el-icon-plus"
            >新增站点</el-button
          >
        </el-form-item>
      </el-form>
      <el-table
        :data="ruleForm.schoolBusSiteList"
        border
        height="350px"
        style="width: calc(100% - 40px);margin:0px 20px"
      >
        <el-table-column
          prop="siteSequence"
          label="站点序号"
          align="center"
          width="100px"
        >
        </el-table-column>
        <el-table-column prop="siteName" label="站点名称" align="center">
          <template slot-scope="scope">
            <el-input
              v-model.trim="scope.row.siteName"
              size="small"
              clearable
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="siteArrivalTime" label="到站时间" align="center">
          <template slot-scope="scope">
            <el-time-picker
              v-model="scope.row.siteArrivalTime"
              placeholder="到站时间"
              value-format="timestamp"
              size="small"
              clearable
            >
            </el-time-picker>
          </template>
        </el-table-column>
        <el-table-column
          prop="siteGeographicLocation"
          label="地理位置"
          align="center"
        >
          <template slot-scope="scope">
            <el-link
              type="primary"
              @click="getLocation(scope.$index, scope.row)"
              :underline="false"
              >{{ scope.row.siteGeographicLocation || "添加" }}</el-link
            >
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="200">
          <template slot-scope="scope">
            <el-button
              type="warning"
              plain
              @click="dataInterposition(scope.$index)"
              size="mini"
              icon="el-icon-edit"
              >插入</el-button
            >
            <el-button
              type="danger"
              plain
              @click="deletBusRoute(scope.$index)"
              size="mini"
              icon="el-icon-delete-solid"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="save-box">
      <div class="cut_off_rule"></div>
      <div class="button_box">
        <el-button
          type="primary"
          size="small"
          plain
          @click="saveClick('ruleForm')"
          >提交</el-button
        >
        <el-button size="small" plain @click="close">取消</el-button>
      </div>
    </div>
    <el-dialog
      width="50%"
      title="地理位置"
      :visible.sync="mapDialog"
      append-to-body
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="map_box">
        <div class="map_item_box">
          <baidu-map
            v-if="mapDialog"
            ref="map"
            class="map"
            :center="center"
            :zoom="15"
            :scroll-wheel-zoom="true"
            :double-click-zoom="false"
            @click="sel"
            @ready="onBaiduMapReady"
          >
            <bm-navigation anchor="BMAP_ANCHOR_TOP_LEFT"></bm-navigation>
            <bm-marker
              :position="positionInfo"
              :dragging="true"
              animation="BMAP_ANIMATION_BOUNCE"
              :icon="{
                url: require('@/assets/img/edu/marker_sprite.png'),
                size: { width: 20, height: 40 }
              }"
            >
            </bm-marker>
          </baidu-map>
        </div>
        <div class="save-box">
          <div class="cut_off_rule"></div>
          <div class="button_box">
            <el-button type="primary" size="small" plain @click="mapAddClick"
              >添加</el-button
            >
            <el-button size="small" plain @click="cencelMapClick"
              >取消</el-button
            >
          </div>
        </div>
      </div>
    </el-dialog>
  </el-dialog>
</template>

<script>
//这里可以引入其他文件（比如组件，工具js，第三方插件js，json文件，图片文件等等）
//列如：import <<组件名称>> from '《组件路径》';
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  props: {
    showDialog: {
      type: Boolean,
      default: () => {
        return false;
      }
    },
    info: {
      type: Object,
      default: () => {
        return {};
      }
    },
    type: {
      type: String,
      default: () => {
        return "add";
      }
    }
  },
  data() {
    //这里存放数据
    return {
      ruleForm: {
        routeName: "",
        schoolBusSiteList: []
      },
      rules: {
        routeName: [
          { required: true, message: " ", trigger: "blur" }
        ]
      },
      mapDialog: false,
      tableIndex: 0,
      center: {
        lng: 113.665412,
        lat: 34.757975
      },
      positionInfo: {},
      BMap: null,
      pitchMapInfo: {
        siteGeographicLocation: "",
        siteLatitudeLongitude: ""
      }
    };
  },
  //监控data中的数据变化
  watch: {
    showDialog: function(val) {
      if (val) {
        this.ruleForm = this.info;
      }
    }
  },
  //计算属性，类似于data概念
  computed: {},
  //方法集合
  methods: {
    close() {
      this.$emit("close");
    },
    addSiteClick() {
      let obj = {
        siteArrivalTime: "",
        siteGeographicLocation: "",
        siteLatitudeLongitude: "",
        siteName: "",
        siteSequence: this.ruleForm.schoolBusSiteList.length + 1
      };
      this.ruleForm.schoolBusSiteList.push(obj);
    },
    getLocation(index, info) {
      if (info.siteLatitudeLongitude) {
        let obj = {
          lng: info.siteLatitudeLongitude.split(",")[0],
          lat: info.siteLatitudeLongitude.split(",")[1]
        };
        this.positionInfo = obj;
        this.center = obj;
      }
      this.tableIndex = index;
      this.mapDialog = true;
    },
    saveClick(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$emit("saveClick", this.ruleForm);
        } else {
          return false;
        }
      });
    },
    mapAddClick() {
      this.ruleForm.schoolBusSiteList[
        this.tableIndex
      ].siteGeographicLocation = this.pitchMapInfo.siteGeographicLocation;
      this.ruleForm.schoolBusSiteList[
        this.tableIndex
      ].siteLatitudeLongitude = this.pitchMapInfo.siteLatitudeLongitude;
      this.mapDialog = false;
    },
    cencelMapClick() {
      this.mapDialog = false;
    },
    // ready事件：在你需要二次开发或手动控制其子组件，可以使用在此事件中使用返回的 BMap 类和 map 实例进行手动控制
    onBaiduMapReady(e) {
      this.BMap = e.BMap;
    },
    sel(e) {
      let self = this;
      const geoCoder = new this.BMap.Geocoder();
      geoCoder.getLocation(e.point, function(res) {
        let point = e.point;
        self.positionInfo = point;
        self.pitchMapInfo = {
          siteGeographicLocation: res.address || "",
          siteLatitudeLongitude: point.lng + "," + point.lat
        };
      });
    },
    dataInterposition(index) {
      let obj = {
        siteArrivalTime: "",
        siteGeographicLocation: "",
        siteLatitudeLongitude: "",
        siteName: "",
        siteSequence: ""
      };
      this.ruleForm.schoolBusSiteList.splice(index + 1, 0, obj);
      this.ruleForm.schoolBusSiteList = this.ruleForm.schoolBusSiteList.map(
        (item, index) => {
          item.siteSequence = index + 1;
          return item;
        }
      );
    },
    deletBusRoute(index) {
      this.ruleForm.schoolBusSiteList.splice(index, 1);
      this.ruleForm.schoolBusSiteList = this.ruleForm.schoolBusSiteList.map(
        (item, index) => {
          item.siteSequence = index + 1;
          return item;
        }
      );
    }
  },
  //生命周期，创建完成（可以访问当前this实例）
  created() {},
  //生命周期，挂载完成（可以访问dom元素）
  mounted() {},
  beforeCreate() {}, //生命周期-创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之后
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroy() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.dlialog-box {
  height: 500px;
  width: 100%;
}
.save-box {
  height: 50px;
  width: 100%;
}
.cut_off_rule {
  width: 100%;
  height: 1px;
  margin: 2px;
  background-color: gray;
}
.button_box {
  float: right;
  margin-right: 20px;
  height: 45px;
  display: flex;
  align-items: center;
  flex-direction: row;
}
.site_add_box {
  float: right;
}
.map_box {
  height: 450px;
  width: 100%;
}
.map_item_box {
  height: 400px;
  width: 100%;
  padding: 5px;
}
.map {
  width: 100%;
  height: 100%;
}
</style>
